import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
import { BrokerStatusType } from '@apply/constants';
import { BrokerClientsTable } from './tables/BrokerClientsTable';
import { StatusHistoryTable } from './tables/StatusHistoryTable';
import { UserAgreementsTable } from './tables/UserAgreementsTable';
import { ContactAddressSection } from '../../../components/ContactAddressSection/ContactAddressSection';
import { HomeAddressSection } from '../../../components/HomeAddressSection/HomeAddressSection';
import { Tab, TabKeyIdentifierPrefix, TabPanel, TabPanelTheme } from '@apply/components';
import { ShowIf } from '@apply/ui';

const tabNames = ['B-Clients', 'Contact Address', 'Home Address', 'Status History', 'User Agreements'];

export const AdditionalInformationPanel = () => {
    const brokerStatus = useBrokerDetailsStore((s) => s.brokerStatus);
    const id = useBrokerDetailsStore((s) => s.id);
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);

    return (
        <>
            <h2 className='decorated'>Additional Information</h2>
            <TabPanel
                id='additionalInfoTabPanel'
                theme={TabPanelTheme.Blue}
                width='100%'
                height='450px'
            >
                <ShowIf showIf={brokerStatus === BrokerStatusType.Activated}>
                    <Tab
                        id={`${TabKeyIdentifierPrefix}0`}
                        key={`${TabKeyIdentifierPrefix}0`}
                        text={tabNames[0]}
                    >
                        <BrokerClientsTable />
                    </Tab>
                </ShowIf>
                <Tab
                    id={`${TabKeyIdentifierPrefix}1`}
                    key={`${TabKeyIdentifierPrefix}1`}
                    text={tabNames[1]}
                >
                    <ContactAddressSection />
                </Tab>
                <Tab
                    id={`${TabKeyIdentifierPrefix}2`}
                    key={`${TabKeyIdentifierPrefix}2`}
                    text={tabNames[2]}
                >
                    <HomeAddressSection />
                </Tab>
                <ShowIf showIf={id > 0 && isAdmin}>
                    <Tab
                        id={`${TabKeyIdentifierPrefix}3`}
                        key={`${TabKeyIdentifierPrefix}3`}
                        text={tabNames[3]}
                    >
                        <StatusHistoryTable />
                    </Tab>
                </ShowIf>
                <ShowIf showIf={id > 0 && isAdmin}>
                    <Tab
                        id={`${TabKeyIdentifierPrefix}4`}
                        key={`${TabKeyIdentifierPrefix}4`}
                        text={tabNames[4]}
                    >
                        <UserAgreementsTable />
                    </Tab>
                </ShowIf>
            </TabPanel>
        </>
    );
};
